var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconuser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1486BA;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#00498C;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st3{clip-path:url(#SVGID_2_);}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#B4D039;}\r\n\t.st5{fill:#00498C;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:#FF7800;}\r\n\t.st8{opacity:0.8;}\r\n\t.st9{fill:#8E8E90;}\r\n\t.st10{opacity:0.81;}\r\n\t.st11{fill:#1486BA;}\r\n\t.st12{opacity:0.8;clip-path:url(#SVGID_4_);fill:#8E8E90;}\r\n\t.st13{clip-path:url(#SVGID_4_);fill:#F6F7F9;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    cx: 65,
    cy: 65,
    r: 53
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8_",
    x: 7,
    y: -6.48,
    style: {
      opacity: 0.8,
      clipPath: "url(#SVGID_2_)",
      fill: "#8E8E90"
    },
    width: 116,
    height: 116.53
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#F6F7F9"
    },
    d: "M65,23.04c-2.64,0-5.4,0.37-8.27,1.91 c-8.86,4.76-8.42,8.86-8.42,12.85s-0.33,11.85-0.33,11.85c-2.22-1.01-1.11,1.33-1.11,5.09s2.1,4.98,2.1,4.98 c0.33,7.75,4.13,9.89,4.13,9.89l-0.74,7.9c-3.32,0.07-1.48,2.81-2.58,3.4c-1.11,0.59-1.26,3.62-1.26,3.62 C16.2,96.71,19.3,101.58,19.3,101.58h91.4c0,0,3.1-4.87-29.24-17.06c0,0-0.15-3.03-1.26-3.62c-1.11-0.59,0.74-3.32-2.58-3.4 l-0.74-7.9c0,0,3.8-2.14,4.13-9.89c0,0,2.1-1.22,2.1-4.98s1.11-6.11-1.11-5.09c0,0-0.33-7.86-0.33-11.85s0.44-8.08-8.42-12.85 C70.4,23.4,67.64,23.04,65,23.04z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#F6F7F9"
    },
    cx: 67.5,
    cy: 109.5,
    rx: 50.5,
    ry: 22.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconuser);
export default __webpack_public_path__ + "static/media/iconuser.99a71b30160b06b0b071b55786be3a25.svg";
export { ForwardRef as ReactComponent };